import { gql } from '@apollo/client'
import { MUTATION_STATE } from 'api/fragments'

const PAYLOAD_TYPE = 'CopyVoohCampaignPayload'

export const COPY_VOOH_CAMPAIGN = gql`
  ${MUTATION_STATE(PAYLOAD_TYPE)}
  mutation copyVoohCampaign($id: ID!) {
    copyVoohCampaign(input: { id: $id }) {
      ...MutationState${PAYLOAD_TYPE}Fields
    }
  }
`
